/**
 * ARAM Platform - Theme Store
 * Core Desarrollos S.A.S - Copyright 2024-2026
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Theme = 'light' | 'dark' | 'system'

/** Applies (or removes) the `dark` class on <html> based on the given theme */
export function applyTheme(theme: Theme) {
  const root = document.documentElement
  const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  root.classList.toggle('dark', theme === 'dark' || (theme === 'system' && systemDark))
}

interface ThemeState {
  theme: Theme
  setTheme: (theme: Theme) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (theme) => {
        applyTheme(theme)
        set({ theme })
      },
    }),
    {
      name: 'aram-theme',
      onRehydrateStorage: () => (state) => {
        if (!state) return
        applyTheme(state.theme)
        // Keep dark class in sync when OS preference changes
        window
          .matchMedia('(prefers-color-scheme: dark)')
          .addEventListener('change', () => {
            if (useThemeStore.getState().theme === 'system') {
              applyTheme('system')
            }
          })
      },
    }
  )
)
